export const useElectricPluginSeriesNames = () => {
  return ["prius prime", "rav4 prime"]
}

export const electricSeriesNames = () => {
  return ["bz4x"]
}
